@if (taskModalService.task$ | async; as task) {
  <h3 translate>Scheduling</h3>
  <table>
    <caption translate hidden>
      Scheduling
    </caption>
    <tr>
      <th scope="row" translate>Status</th>
      <td>{{ (task.executionDate ? 'Task done' : 'Task skipped') | translate }}</td>
    </tr>
    <tr>
      <th scope="row" translate>Due Date</th>
      <td>{{ (task.dueDate | localizedDate: 'shortDate') || '-' }}</td>
    </tr>
    <tr>
      <th scope="row" translate>Execution Date</th>
      <td>{{ (task.executionDate | localizedDate: 'shortDate') || '-' }}</td>
    </tr>
    <tr>
      <th scope="row" translate>Shifted at</th>
      @if (task.shiftings?.length) {
        <td>
          @for (shift of task.shiftings; track shift) {
            <span> {{ shift.timeStamp | localizedDate: 'shortDate' }}&nbsp; &nbsp; </span>
          }
        </td>
      } @else {
        <td>-</td>
      }
    </tr>
    <tr>
      <th scope="row" translate>Skipped at</th>
      <td>{{ (task.skipInfo?.timeStamp | localizedDate: 'shortDate') || '-' }}</td>
    </tr>
  </table>
}
